<template>
  <div class="FormField">
    <component
      :is="tag"
      :class="tag === 'p' ? 'statement' : ['gl_heading', 'secondary']"
    >
      {{ statement }}
    </component>

    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps({
  statement: {
    type: String,
    default: null
  },
  tag: {
    type: String,
    default: 'p',
    validator: (value: string) => ['p', 'h3'].includes(value)
  }
})
</script>

<style lang="scss" scoped>
.FormField {
  margin-top: $spacing-l;

  .statement {
    font-family: $font-family-primary;
    font-size: $font-size-m;
    font-style: normal;
    font-weight: $font-weight-400;
    line-height: $line-height-100p;
    color: $color-neutral-dark;
    margin-bottom: $spacing-s;
  }

  :deep(.v-input) {
    font-family: $font-family-primary;
  }
}
</style>
